import React, { useState, useEffect } from "react";
import { ToastContainer } from "pepsico-ds";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutRadioActions } from "../redux/closeoutslice/closeOutRadioSlice";

const AppToaster: React.FC = () => {
  const [toastData, setToastData] = useState<any>([]);
  const dispatch = useDispatch();
  const { snackbarItems } = useSelector((state: any) => state.CloseOutRadio);
  useEffect(() => {
    if (snackbarItems.message && snackbarItems.severity) {
      const mappedToasts = [
        {
          id: 0,
          duration: 5000,
          text: snackbarItems.message,
          type: snackbarItems.severity,
        },
      ];
      setToastData(mappedToasts);
    } else {
      setToastData([]);
      return;
    }
  }, [snackbarItems]);
  const removeToast = () => {
    dispatch(CloseOutRadioActions.resetSnackBar());
    setToastData([]);
  };
  return (
    <ToastContainer
      data={toastData}
      position="bottom-right"
      removeToast={removeToast}
      showActionIcon={toastData[0]?.text !== ""}
    />
  );
};

export default AppToaster;
